import { color } from "../resource";

export const MAP_STATUS_WORD_TOUR = {
  WAIT_APPROVE: "รออนุมัติ",
  INACTIVE: "ปิดใช้งาน",
  EXPIRE: "หมดอายุ",
  PENDING: "รอเริ่ม",
  ACTIVE: "เปิดใช้งาน",
  APPROVE: "อนุมัติ",
};

export const MAP_STATUS_TOUR: any = {
  WAIT_APPROVE: color["warning"],
  ACTIVE: color["success"],
  INACTIVE: color["Text3"],
  PENDING: color["secondary2"],
  EXPIRE: color["Text3"],
  APPROVE: color["success"],
};
export const mapStatusEdit = (status: string, isApproved: boolean) => {
  let isEdit = false;
  if (isApproved) {
    isEdit = status === "ACTIVE" ? true : false;
  }
  return isEdit;
};
